import { DARK_CONTRAST_SELECTORS, TEXT_SELECTORS } from "./Selectors";
import IToolConfig from "../types/IToolConfig";

export interface IFilters {
    [key: string]: IToolConfig
}

export const FILTERS: IFilters = {
    'dark-contrast': {
        styles: {
            'color': '#FFF',
            'fill': '#FFF',
            'background-color': '#181818'
        },
        childrenSelector: DARK_CONTRAST_SELECTORS as string[],
        mainSelector:''
    },
    'light-contrast': {
        styles: {
            'color': '#000',
            'fill': '#000',
            'background-color': '#FFF'
        },
        childrenSelector: TEXT_SELECTORS as string[],
        mainSelector:''
    },
    'high-contrast': {
        styles: {
            'filter': 'contrast(110%)'
        },
        mainSelector:':not(html):not(body)'
    },
    'high-saturation': {
        styles: {
            'filter': 'saturate(110%)'
        },
        mainSelector:':not(html):not(body)'
    },
    'low-saturation': {
        styles: {
            'filter': 'saturate(87%)'
        },
        mainSelector:':not(html):not(body)'
    },
    'monochrome': {
        styles: {
            'filter': 'grayscale(100%)'
        },
        mainSelector:':not(html):not(body)'
    }
}

export default FILTERS